import { isSameVin, vinSearchQuery, FULL_VIN_LENGTH } from '../../Car/NewCar/vinSearch';

// Форму нового авто показываем, когда VIN введён целиком, поиск по нему закончился и точного совпадения в базе нет.
// Пока поиск идёт (или VIN ещё короткий), формы нет: иначе она мигала бы на каждом нажатии клавиши.
export const needsNewCar = (vin, search) =>
  String(vin || '').length === FULL_VIN_LENGTH &&
  Boolean(search?.done) &&
  search.query === vinSearchQuery(vin) &&
  !(search.cars || []).some((car) => isSameVin(car, vin));
